export const hasApensado = (data, next, complete) => {
  return Boolean(data?.apensado || next?.apensado || complete?.apensado);
};

export const isParentApensadoProcess = (data, next, complete) => {
  const isParent = (item) => item?.apensado === true && !item?.apensado_id;

  return Boolean(isParent(data) || isParent(next) || isParent(complete));
};

// Planos que, por enquanto, se comportam exatamente como o Essencial.
// O "2026" (novo modelo de vendas, 22/09/2026) nasceu assim e será
// diferenciado depois — espelha SalesScope::PLANOS_COMO_ESSENCIAL na API.
export const PLANOS_COMO_ESSENCIAL = ["ESSENTIAL", "PLAN_2026"];

export const isPlanoComoEssencial = (familyPlan) =>
  PLANOS_COMO_ESSENCIAL.includes(familyPlan);

// No plano 2026 a taxa da conservatória é paga pelo cliente (com a equipe,
// pelo WhatsApp) — o card de Despacho muda por causa disso.
export const isPlano2026 = (familyPlan) => familyPlan === "PLAN_2026";

export const isEssentialPlanProcess = (data, next, complete) => {
  return [data, next, complete].some((item) =>
    isPlanoComoEssencial(item?.sale?.family_plan)
  );
};
